import React from "react";
import { Grid, Typography, TextField, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { setFormData } from "features/OrgAdmin/orgAdminSlice";
import { useDispatch } from "react-redux";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: "#f8f9fa",
  borderRadius: theme.spacing(1.5),
  border: "1px solid #e9ecef",
  height: "100%",
}));

export const getSections = (formData, results, dispatch) => {

  console.log("formData12:", formData);

  const sections = [];

  // IF orgId exists → show Journey + Speed Limit
  if (results && results[0]) {
    sections.push(
      {
        title: "Journey Status",
        name: "journeyStatus",
        value: formData.journeyStatus || "",  // FIXED
        options: [
          { value: "enabled", label: "Enable Journey Status" },
          { value: "disabled", label: "Disable Journey Status" },
        ],
      },
      {
        custom: true,
        render: (
          <Grid item xs={12} sm={6} lg={4}>
            <StyledPaper elevation={0}>
              <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                Speed Limit (Kmph):
              </Typography>
              <TextField
                type="number"
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Enter Speed Limit"
                value={formData.speedLimit ?? 0}
                onChange={(e) =>
                  dispatch(
                    setFormData({ ...formData, speedLimit: e.target.value })
                  )
                }
              />
            </StyledPaper>
          </Grid>
        ),
      },
      {
        custom: true,
        render: (
          <Grid item xs={12} sm={6} lg={4}>
            <StyledPaper elevation={0}>
              <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                License Count :
              </Typography>
              <TextField
                type="number"
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Enter License Count"
                value={formData.licenseCount ?? 0} // Update: Use licenseCount
                onChange={(e) =>
                  dispatch(
                    setFormData({ ...formData, licenseCount: e.target.value }) // Update: Dispatch licenseCount
                  )
                }
              />
            </StyledPaper>
          </Grid>
        ),
      }
    );
  }

  // OTHER SECTIONS
  sections.push(
    {
      title: "SMS and Notification feature",
      name: "smsFeature",
      value: formData.smsFeature || "",
      options: [
        { value: "optimized", label: "Push notification and Optimized SMS" },
        { value: "sms", label: "Push notification and SMS" },
        { value: "pushOnly", label: "Push notification only" },
        { value: "disabled", label: "Notification Disabled" },
      ],
    },
    {
      title: "Dhundhoo link feature",
      name: "dhundhooLink",
      value: formData.dhundhooLink || "",
      options: [
        { value: "dontSend", label: "Do not send Dhundhoo link in SMS" },
        { value: "send", label: "Send Dhundhoo link in SMS" },
      ],
    },
    {
      title: "Attendance",
      name: "attendance",
      value: formData.attendance || "",
      options: [
        { value: "enable", label: "Enable Attendance" },
        { value: "disable", label: "Disable Attendance" },
      ],
    },
    {
      title: "Logs",
      name: "logs",
      value: formData.logs || "",
      options: [
        { value: "enable", label: "Enable Logs" },
        { value: "disable", label: "Disable Logs" },
      ],
    },
    {
      title: "Management",
      name: "management",
      value: formData.management || "",
      options: [
        { value: "enable", label: "Enable Management" },
        { value: "disable", label: "Disable Management" },
      ],
    },
    {
      title: "Alerts",
      name: "alerts",
      value: formData.alerts || "",
      options: [
        { value: "enable", label: "Enable Alerts" },
        { value: "disable", label: "Disable Alerts" },
      ],
    },
    {
      title: "Planning",
      name: "planning",
      value: formData.planning || "",
      options: [
        { value: "enable", label: "Enable Planning" },
        { value: "disable", label: "Disable Planning" },
      ],
    },
    {
      title: "Odometer Distance Report",
      name: "odometer",
      value: formData.odometer || "",
      options: [
        { value: "enable", label: "Enable Odometer Disatnce Report" },
        { value: "disable", label: "Disable Odometer Disatnce Report" },
      ],
    },
    {
      title: "Trip Details",
      name: "tripDetails",
      value: formData.tripDetails || "",
      options: [
        { value: "enable", label: "Enable Trip Details" },
        { value: "disable", label: "Disable Trip Details" },
      ],
    },
    {
      title: "Payment Wallet",
      name: "paymentWallet",
      value: formData.paymentWallet || "",
      options: [
        { value: "enable", label: "Enable Payment Wallet" },
        { value: "disable", label: "Disable Payment Wallet" },
      ],
    },
    {
      title: "Job Role",
      name: "jobRole",
      value: formData.jobRole || "",
      options: [
        { value: "enable", label: "Enable Job Role" },
        { value: "disable", label: "Disable Job Role" },
      ],
    },
    {
      title: "Route Optimization",
      name: "routeOptimization",
      value: formData.routeOptimization || "",
      options: [
        { value: "enable", label: "Enable Route Optimization" },
        { value: "disable", label: "Disable Route Optimization" },
      ],
    },
    {
      title: "Fuel Log",
      name: "fuelLog",
      value: formData.fuelLog || "",
      options: [
        { value: "enable", label: "Enable Fuel Log" },
        { value: "disable", label: "Disable Fuel Log" },
      ],
    },
    {
      title: "Live Camera",
      name: "liveCamera",
      value: formData.liveCamera || "",   // FIXED
      options: [
        { value: "enable", label: "Enable Live Camera" },
        { value: "disable", label: "Disable Live Camera" },
      ],
    },
    // {
    //   title: "OrgType",
    //   name: "orgType",
    //   value: formData.orgType || "",
    //     options: [
    //     { value: "SCHOOL", label: "School" },
    //     { value: "CORPORATE", label: "Corporate" },
    //     { value: "TRANSPORT", label: "Transport" },
    //     { value: "OTHER", label: "Other" },
    //   ],
    // },
    {
      title: "Vendor configurations",
      name: "vendorConfigurations",
      value: formData.vendorConfigurations || "",
      options: [
        {
          value: "vendorOnly",
          label: "Notifications & Tracking to vendor clients only",
        },
        {
          value: "vendorPlus",
          label: "Notifications & Tracking to Dhundhoo & vendor clients",
        },
        { value: "noVendor", label: "No vendor involved" },
      ],
    }
  );

  // 🔥 FINAL FIX — REMOVE DUPLICATES
  const uniqueSections = [];
  const names = new Set();

  for (const sec of sections) {
    if (!sec.name) {
      uniqueSections.push(sec);
      continue;
    }
    if (!names.has(sec.name)) {
      names.add(sec.name);
      uniqueSections.push(sec);
    }
  }

  return uniqueSections;
};
